import React from 'react';
import { Select, SelectOption } from '@lifeomic/chroma-react/components/Select';

interface EvidenceLevelFieldComponentProps {
  evidenceLevelValue: fhir.Coding | null;
  evidenceLevelValues: fhir.Coding[];
  observation: fhir.Observation;
  handleEvidenceLevelSelection: (
    Observation: fhir.Observation,
    evidenceLevelValue: fhir.Coding,
  ) => void;
}

export const EvidenceLevelFieldComponent = (
  props: EvidenceLevelFieldComponentProps,
) => {
  const {
    evidenceLevelValue,
    evidenceLevelValues,
    observation,
    handleEvidenceLevelSelection,
  } = props;

  return (
    <Select
      label={''}
      aria-label={`${observation?.id}-evidence-level-selection`}
      onChange={(evidenceLevelValueCode: string) =>
        handleEvidenceLevelSelection(
          observation,
          // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
          evidenceLevelValues.find(
            ({ code }) => code === evidenceLevelValueCode,
          ),
        )
      }
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      value={evidenceLevelValue?.code || null}
    >
      {evidenceLevelValues.map(({ code, display }) => (
        <SelectOption
          key={`evidence-level-selection-${code}`}
          // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
          value={code}
          title={display}
          subtitle={code}
        />
      ))}
    </Select>
  );
};
